Description: ShowVideoUrl is a landing page that is added to count the clicks of
users when selecting a video from the email. The URL looks like:
http://localhost:8080/showVideo?PromotionMessageManagerId=A3HXFV6AA_UG_643_PMM&SourceKey=IND7ZL8E8PFJX3MKH5&VideoId=F_Ssr3nxQHY7UM5TCER3L4VBMXVirgh7DA
The Vue router (index.js) will see the showVideo tag in the URL path and set the
store property showVideoUrl to true. When the App.vue is loaded, it will check
on this property and show the landing page 'ShowVideoUrl' without loading
partnerGroup data, user data, etc. Just an empty web page. The ShowVideoUrl
component will scan the query parameters of the URL path and sends them in a
getVideoUrl request to the BackEnd, receiving the video url, which will be
played in a simple video player.

<template>
  <div v-if="parameterError">
    <h1>ERROR! Invalid URL.</h1>
  </div>
  <section v-else class="video-container">
    <video class="video" autoplay muted :src="videoUrl" controls />
    <v-btn
      v-if="eventId !== '' && eventId !== null"
      @click="viewPromotion"
      color="primary"
      style="position: relative; top: 10%; left: 3%"
      class="primary-font-color"
      >{{ $translate('VIEW_DETAILS') }}</v-btn
    >
  </section>
</template>

<script>
import doRequest, { addLog } from '@/api/dssRequest';

export default {
  name: 'ShowVideoUrl',
  data() {
    return {
      parameterError: false,
      promotionMessageManagerId: '',
      sourceKey: '',
      videoId: '',
      videoUrl: '',
      userId: '',
      eventId: '',
    };
  },
  mounted() {
    console.log('Component ShowVideoUrl mounted.');
    if (!this.getUrlParameters()) return;
    this.getVideoUrl();
  },
  methods: {
    getUrlParameters() {
      // Get the url
      const url_string = window.location.href;
      const url = new URL(url_string);
      // Read the parameters
      this.promotionMessageManagerId = url.searchParams.get(
        'PromotionMessageManagerId'
      );
      this.sourceKey = url.searchParams.get('SourceKey');
      this.videoId = url.searchParams.get('VideoId');
      this.userId = url.searchParams.get('UserId');
      this.eventId = url.searchParams.get('EventId');
      // Check if all parameters are valid.
      if (
        this.promotionMessageManagerId === null ||
        this.promotionMessageManagerId === '' ||
        this.sourceKey === null ||
        this.sourceKey === '' ||
        this.videoId === null ||
        this.videoId === ''
      ) {
        console.log(
          'ShowVideoUrl - ERROR! Invalid parameters. promotionMessageManagerId=',
          this.promotionMessageManagerId,
          ', sourceKey=',
          this.sourceKey,
          ', videoId=',
          this.videoId
        );
        this.parameterError = true;
        return false;
      }

      console.log(
        'ShowVideoUrl - Valid parameters promotionMessageManagerId=',
        this.promotionMessageManagerId,
        ', sourceKey=',
        this.sourceKey,
        ', videoId=',
        this.videoId
      );
      return true;
    },
    getVideoUrl() {
      const payload = {
        PromotionMessageManagerId: this.promotionMessageManagerId,
        SourceKey: this.sourceKey,
        VideoId: this.videoId,
        UserId: this.userId,
      };

      doRequest(
        (response) => {
          if (response.success) {
            this.videoUrl = response.data.VideoUrl;
            if(this.eventId && this.eventId !== '' && this.eventId !== null){
            addLog(
              this.$store.getters['auth/userName'],
              this.eventId,
              'Event',
              'Email',
              -1
            );
            }
            console.log('ShowVideoUrl - Received videoUrl: ', this.videoUrl);
          } else {
            console.log(
              'ShowVideoUrl - ERROR! Received a failure response on getVideoUrl request. ',
              response.errorMsg
            );
            this.parameterError = true;
          }
        },
        (response) => {
          console.log(
            'ShowVideoUrl - ERROR! Failed to receive a response on getVideoUrl request. ',
            response.errorMsg
          );
          this.parameterError = true;
        },
        'getVideoUrl',
        this.promotionMessageManagerId,
        payload,
        'GET'
      );
    },
    viewPromotion() {
      this.$router.push({
        name: 'EventDetails',
        params: { event_id: this.eventId },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.video-container {
  position: relative;
  background-color: black;
  width: 100vw;
  height: 100vh;
}
.video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 10%;
  max-width: 100%;
  min-height: 10%;
  max-height: 100%;
}
</style>
